import type { priceLists as enPriceLists } from "../en/priceLists";

export const priceLists: typeof enPriceLists = {
  pageHeading: "Listini prezzi",
  status: {
    ACTIVE: "Attivo",
    ARCHIVED: "Archiviato",
  },
  actions: {
    archive: "Archivia",
    restore: "Ripristina",
  },
  form: {
    nameLabel: "Nome",
    currencyLabel: "Codice valuta",
  },
  createSection: {
    heading: "Crea un listino prezzi",
    description:
      "Imposta prezzi B2B fissi per variante prodotto, poi assegna il listino a un'azienda. I nuovi preventivi per quell'azienda precompileranno ogni riga dal listino — potrai comunque modificare qualsiasi riga.",
    namePlaceholder: "es. Ingrosso 2026",
    submitButton: "Crea listino prezzi",
  },
  list: {
    heading: "I tuoi listini prezzi ({{count}})",
    hideArchived: "Nascondi archiviati",
    showArchived: "Mostra archiviati",
    empty: "Ancora nessun listino prezzi. Creane uno qui sopra per iniziare a offrire condizioni B2B negoziate.",
    variantCountOne: "{{count}} variante",
    variantCountOther: "{{count}} varianti",
    companyCountOne: "{{count}} azienda",
    companyCountOther: "{{count}} aziende",
    updated: "Aggiornato il {{date}}",
  },
  errors: {
    nameRequired: "Inserisci un nome per il listino prezzi.",
    createFailed: "Non è stato possibile creare il listino prezzi.",
    missingId: "ID listino prezzi mancante.",
    notFound: "Listino prezzi non trovato.",
    nameRequiredSave: "Il nome è obbligatorio.",
    entriesInvalid: "Il payload delle voci non è valido.",
    tooManyEntries: "Il listino prezzi supera le 5000 voci.",
    invalidPrice: "Prezzo non valido per {{title}}.",
    entryMustReferenceVariant: "Ogni voce deve fare riferimento a una variante prodotto.",
    currencyChangeWarning:
      'Cambiare la valuta da {{from}} a {{to}} NON converte i prezzi esistenti — ogni importo verrà reinterpretato come {{to}}. Seleziona "Ho capito" qui sotto per confermare, oppure mantieni la valuta {{from}}.',
    saveFailed: "Non è stato possibile salvare il listino prezzi.",
  },
  edit: {
    heading: "Modifica listino prezzi",
    pickerUnavailable: "Il selettore prodotti non è disponibile. Apri questa app dall'interno dell'admin Shopify.",
    archivedBanner: "Questo listino prezzi è archiviato — non precompila più i nuovi preventivi. Ripristinalo per usarlo di nuovo.",
    assignmentBannerOne:
      "Assegnato a {{count}} azienda. Modificare i prezzi qui cambia il precompilato dei loro preventivi futuri (i preventivi esistenti non sono interessati).",
    assignmentBannerOther:
      "Assegnato a {{count}} aziende. Modificare i prezzi qui cambia il precompilato dei loro preventivi futuri (i preventivi esistenti non sono interessati).",
    detailsHeading: "Dettagli",
    currencyChangeNotice:
      "Cambiare la valuta non converte i prezzi esistenti — ogni importo viene reinterpretato nella nuova valuta, non ricalcolato.",
    confirmCurrencyCheckbox: "Ho capito — cambia la valuta senza convertire i prezzi",
    variantsHeading: "Prezzi delle varianti ({{count}})",
    noVariantsBody: 'Ancora nessuna variante. Fai clic su "Aggiungi prodotti" per scegliere le varianti e impostarne il prezzo fisso.',
    skuLabel: "SKU {{sku}}",
    priceFieldLabel: "Prezzo in {{currency}}",
    removeButton: "Rimuovi",
    addProductsButton: "Aggiungi prodotti",
    addMoreProductsButton: "Aggiungi altri prodotti",
    saveButton: "Salva listino prezzi",
    statusHeading: "Stato",
    archiveButton: "Archivia listino prezzi",
    restoreButton: "Ripristina listino prezzi",
  },
};
